<template lang="html">
  <v-container>
    <v-row>
      <v-col class="xs-12" cols="12">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">{{getBusiness.name}} Members</v-toolbar-title>
          </v-toolbar>
          <v-row>
            <v-col xs5 cols="5" class="members-setting-default-height">
              <StandardMembersList @selectIndex="selectIndex($event), add_new=false" :members="getBusinessMembers" :selected_index="selected_index" :current_user="getUser">
                <template #add-member>
                  <v-list-item v-if="hasBusinessPermission('Add Users')">
                    <v-list-item-avatar class="cursor-pointer" :color="add_new ? 'green' : 'grey'" small @click="!add_new ? add_new = true : (addUsers({
                        business_id: getBusiness.id,
                        payload: {users: [{ email: new_member.email, brole_id: new_member.brole.id }]}
                      }), resetNewMember())">
                      <v-icon v-if="!add_new">add</v-icon>
                      <v-icon class="ml-1" v-else>send</v-icon>
                    </v-list-item-avatar>
                    <div v-if="add_new">
                      <v-list-item-content>
                        <StandardTextfield
                          color="grey darken-1"
                          textcolor="white"
                          placeholder="Email Address"
                          :value="new_member.email"
                          @changeValue="setNewUserEmail($event)"
                          style="width: 90%"
                          />
                        <StandardDropdown
                          :value="new_member.brole.id !== 0 ? new_member.brole.name:'select Role'"
                          color="grey darken-1"
                          :options="business_roles"
                          @changeValue="setNewUserBRole($event)"
                        />
                      </v-list-item-content>
                    </div>
                    <v-list-item-content v-else @click="add_new = true" class="cursor-pointer">
                      Add new Member
                    </v-list-item-content>
                  </v-list-item>
                  <v-alert v-if="getAddMemberError !== ''" type="error" @click="resetAddMemberError()">
                    {{ getAddMemberError }}
                  </v-alert>
                </template>
              </StandardMembersList>
            </v-col>
            <v-col xs7 cols="7" class="members-setting-default-height">
              <StandardMembersDetails :member="getBusinessMembers[selected_index]">
                <template #role="{member}">
                  <v-list-item-title v-if="!edit_role">{{member.brole.name}}</v-list-item-title>
                  <v-list-item-title v-if="edit_role">
                    <StandardDropdown
                      class="ma-0"
                      header="Select Role:"
                      :value="change_brole.name"
                      @changeValue="change_brole = $event"
                      placeholder="Business Roles"
                      :options="business_roles"
                    />
                  </v-list-item-title>
                </template>
                <template #role-actions="{member}">
                  <v-btn v-if="hasBusinessPermission('Add Users') && !edit_role"
                        icon
                        color="green"
                        class="pull-right"
                        @click="edit_role = true"
                        >
                        <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn v-if="edit_role"
                        icon
                        color="red"
                        class="pull-right"
                        @click="edit_role = false"
                        >
                        <v-icon>cancel</v-icon>
                  </v-btn>
                  <v-btn v-if="edit_role"
                        icon
                        color="green"
                        class="pull-right"
                        @click="requestUpdateMemberBRole({
                          business_id: getBusiness.id,
                          payload: {users: [{ id: member.id, brole_id: change_brole.id }]}
                          })"
                        >
                        <v-icon>done</v-icon>
                  </v-btn>
                </template>
                <template #remove-member="{member}">

                  <v-list-item
                    v-if="hasBusinessPermission('Remove Users') && getUser.id !== member.id"
                    class="list-item-bg">
                    <v-list-item-action>
                      <v-icon color="snow">cancel</v-icon>
                    </v-list-item-action>
                    <v-list-item-content v-if="!show_delete">
                      <v-btn @click="show_delete=true" text>Remove Member {{ member.first_name + ' ' + member.last_name }}</v-btn>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                      <v-btn @click="removeUsers({
                          business_id: getBusiness.id,
                          payload: {users: [{ id: member.id }]}
                        }), resetMemberDetails()" text>Click again to remove {{member.first_name + ' ' + member.last_name}}</v-btn>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </StandardMembersDetails>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import StandardMembersList from '@/components/StandardComponents/StandardMembersList.component.vue'
import StandardMembersDetails from '@/components/StandardComponents/StandardMembersDetails.component.vue'
import StandardDropdown from '@/components/StandardComponents/StandardDropdown.component.vue'
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue'
// import TIconButton from '@/components/Taktify/TIconButton.component.vue'

import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'CompanyManage',
  components: {
    StandardMembersList,
    StandardDropdown,
    StandardMembersDetails,
    StandardTextfield,
    // TIconButton
  },
  data: function () {
    return {
      selected_index: 0,
      show_delete: false,
      edit_role: false,
      business_roles: [],
      change_brole: {
        name: '',
        id: 0
      },
      add_new: false,
      new_member: {
        email: '',
        brole: {
          id: 0,
          name: ''
        }
      },
      projects_select: false,
      selection: []
    }
  },
  created(){
    this.business_roles = this.getBusinessRoles;
  },
  computed: {
    ...mapGetters('Auth', [
      'getUser'
    ]),
    ...mapGetters('Business', [
      'getBusiness',
      'getAddMemberError',
      'getBusinessProjects',
      'getBusinessMembers',
      'getBusinessRoles',
      'hasBusinessPermission'
    ])
  },
  methods: {
    ...mapActions('Business', [
      'removeUsersFromBusiness',
      'addUsers',
      'removeUsers',
      'updateMemberBRole',
      'removeProjects',
      'resetAddMemberError'
    ]),
    requestUpdateMemberBRole(payload){
      this.updateMemberBRole(payload);
      let self = this;
      setTimeout(function () {
        self.edit_role = false;
      }, 1500);
    },
    selectIndex(index){
      this.selected_index = index;
    },
    setNewUserEmail(event){
      this.new_member.email = event;
    },
    setNewUserBRole(event){
      this.new_member.brole = event;
    },
    selectOrDeselect(id){
      let index = this.selection.indexOf(id);
      if (index === -1) {
        this.selection.push(id);
      } else {
        this.selection.splice(index, 1);
      }
    },
    isInSelection(id){
      if (this.selection.indexOf(id) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    projectClick(project){
      if (this.projects_select) {
        // select / deselect
        this.selectOrDeselect(project.id);
      } else {
        // route to project
        if (project.calling_user_is_member) {
          this.$router.push({name: 'Project', params: {project_id: project.id}});
        } else {
          this.$router.push({name: 'CompanyJoinProject', params: {project_id: project.id}});
        }
      }
    },
    requestRemoveProjects(){
      let projects = [];
      for (let i = 0; i < this.selection.length; i++) {
        projects.push({ id: this.selection[i]});
      }
      this.removeProjects({
        business_id: this.getBusiness.id,
        payload: {projects: projects}
      });
    },
    resetNewMember(){
      this.new_member = {
        email: '',
        brole: {
          id: 0,
          name: ''
        }
      };
      this.add_new = false;
    },
    resetMemberDetails(){
      this.selected_index = 0;
      this.show_delete = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.members-setting-default-height {
  max-height: 600px;
  overflow-y: auto;
}
.list-item-bg {
  background-color: red;
}
</style>
